/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Paper, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';

type FormData = {
    search: string;
};

export const SearchButton = () => {
    const { handleSubmit, control } = useForm<FormData>();
    const [searchParams] = useSearchParams();
    const query = searchParams.get('query') || '';
    const navigate = useNavigate();

    const submitForm = ({ search }: FormData) => {
        navigate(`/search?query=${search}`);
    };

    return (
        <Paper
            css={css`
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                margin: 0 auto;
                padding: 2px 4px;
                display: flex;
                align-items: center;
                max-width: 500px;
            `}
        >
            <SearchIcon
                css={css`
                    color: rgba(0, 0, 0, 0.54);
                    padding: 0 10px;
                `}
            />
            <form onSubmit={handleSubmit(submitForm)}>
                <Controller
                    name="search"
                    control={control}
                    defaultValue={query}
                    rules={{ required: 'Search criteria required' }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <TextField
                            variant="standard"
                            value={value}
                            onChange={onChange}
                            error={!!error}
                            helperText={error ? error.message : null}
                            css={css`
                                padding: 10px 0;
                                width: 420px;
                            `}
                        />
                    )}
                />
            </form>
        </Paper>
    );
};
